import { useEffect } from "react";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Icon from "../../../components/Icon";
import styles from "./Modal.module.sass";
import { createPortal } from "react-dom";
import Reader from "./Reader";

const QrReader = ({ visible, onClose }) => {
	useEffect(() => {
		const target = document.querySelector("#modal-QrReader");
		if (visible) {
			disableBodyScroll(target);
		} else {
			if (target) enableBodyScroll(target);
		}
	}, [visible]);

	return createPortal(
		visible && (
			<div id="modal-QrReader" className={styles.modal}>
				<div className={styles.control}></div>
				<div className={styles.outer}>
					<button className={styles.close} onClick={onClose}>
						<Icon name="close" size="20" />
					</button>
					<Reader />
				</div>
			</div>
		),
		document.body
	);
};

export default QrReader;
